import { render, staticRenderFns } from "./getDiscount.vue?vue&type=template&id=5f41b070&scoped=true"
import script from "./getDiscount.vue?vue&type=script&lang=js"
export * from "./getDiscount.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./getDiscount.vue?vue&type=style&index=0&id=5f41b070&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5f41b070",
  "1fb3aebd"
  
)

export default component.exports